import { FIESTA_IFRAME_MESSAGE_ACTIONS } from '../fiesta.constants';
import useIframeMessageHandler from './useIframeMessageHandler';

const useAuthTokenIframeListener = () => {
  const actionMappings = {
    [FIESTA_IFRAME_MESSAGE_ACTIONS.AUTH_TOKEN_SET]: (params: {
      'x-access-version': string;
      'x-access-token': string;
    }) => {
      if (typeof window !== 'undefined' && window.localStorage) {
        if (params['x-access-token'] !== window.localStorage.getItem('x-access-token')) {
          window.localStorage.setItem('x-access-token', params['x-access-token']);
        }
        if (params['x-access-version'] !== window.localStorage.getItem('x-access-version')) {
          window.localStorage.setItem('x-access-version', params['x-access-version']);
        }
      }
    },
  };
  useIframeMessageHandler(actionMappings);
};

export default useAuthTokenIframeListener;
